import { render, staticRenderFns } from "./VenueRules.vue?vue&type=template&id=3a7e0b4d&scoped=true"
import script from "./VenueRules.vue?vue&type=script&lang=ts"
export * from "./VenueRules.vue?vue&type=script&lang=ts"
import style0 from "./VenueRules.vue?vue&type=style&index=0&id=3a7e0b4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7e0b4d",
  null
  
)

export default component.exports